"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var CashPrices_1 = require("../../prices/cash/CashPrices");
var FinanceQuotePrices_1 = require("../../prices/finance/FinanceQuotePrices");
var carDetailsPricesWithFinanceStyles_1 = require("./carDetailsPricesWithFinanceStyles");
var clsx_1 = require("clsx");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var CarDetailsPricesWithFinance = function (_a) {
    var _b, _c;
    var primary = _a.primary, secondary = _a.secondary, isMultiCurrency = _a.isMultiCurrency, financeDetails = _a.financeDetails;
    var style = carDetailsPricesWithFinanceStyles_1.default();
    return (<core_1.Box className={clsx_1.default(style.wrapper, (_b = {}, _b[style.multiWrapper] = isMultiCurrency, _b))}>
      <CashPrices_1.default primaryPrice={primary} dataTest="summary:text:car_price" secondaryPrice={secondary} isMultiCurrency={isMultiCurrency}/>
      <core_1.Box component="span" className={clsx_1.default(style.prices, (_c = {}, _c[style.multiWrapper] = isMultiCurrency, _c))}>
        <core_1.Divider orientation="vertical" data-test="summary:element:divider" className={style.divider}/>
        <FinanceQuotePrices_1.default primaryPrice={financeDetails.primary} secondaryPrice={financeDetails.secondary} isMultiCurrency={isMultiCurrency} dataTest="price:finance_quote_primary" labelBefore={<Translation_1.default id={'financeSummary.text.from'}/>} labelAfter={financeDetails.frequency} variant={'body1'}/>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = CarDetailsPricesWithFinance;
